import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.FirmInstitutionsEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.FirmInstitutionsList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.FirmInstitutionsCreate })));

export default { edit, list, create };
